// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home } from "./screens/Home";
import { ProjectDetailPage } from "./screens/ProjectDetailPage";
import Navbar from "./component/Header&Footer/Header";
import { Footer } from "./component/Header&Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init();

    const preloader = document.getElementById("preloader");

    if (preloader) {
      // Wait 2 seconds minimum after mount
      setTimeout(() => {
        preloader.style.opacity = "0";
        preloader.style.transition = "opacity 0.5s ease";

        // After fade-out completes, remove from DOM
        setTimeout(() => {
          preloader.remove();
        }, 500); // match with CSS transition
      }, 2000); // minimum visible duration
    }
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/project/:slug/:id" element={<ProjectDetailPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
